import ThumbsDown from './ThumbsDown'

export default ThumbsDown
// eslint-disable-next-line import/export
export * from './ThumbsDown'
